import React, { ChangeEvent, useEffect, useState } from 'react';
import { ReactComponent as CloseGrey } from '../../assets/close-grey.svg';
import styles from './ProcessRefund.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { bundleDetailsSelector } from '../../selectors/bundleSelectors';
import { showPicker } from '../../utils/helper';
import RefundDetails from './RefundDetails';
import RefundOptions from './RefundOptions';
import { TRefundDetails } from '../../types/bundle.types';
import { ReactComponent as LoadingSpinner } from '../../assets/loading-spinner.svg';
import { authTokenSelector } from '../../selectors/userSelectors';
import { getRefundDetailsRequest } from '../../actions/orderActions';
import { FormattedMessage } from 'react-intl';

interface ProcessRefundProps {
  closeModal: () => void;
}

const dummyOrderRefundDetails = {
  currency: 'USD',
  orderRefundDetails: [
    { orderId: 67890, orderType: 'MailSuite', refundableAmount: 10.0 },
    { orderId: 67891, orderType: 'Site', refundableAmount: 5.0 },
    { orderId: 67892, orderType: 'NeoDomain', refundableAmount: 5.0 },
  ],
};

const getRefundStartDate = () => {
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  return {
    today: new Date().toISOString().split('T')[0],
    thirty_days_ago: startDate.toISOString().split('T')[0],
  };
};

const ProcessRefund = (props: ProcessRefundProps) => {
  const { closeModal } = props;
  const dispatch = useDispatch();
  const { domainName, id } = useSelector(bundleDetailsSelector);
  const token = useSelector(authTokenSelector);

  const [refundAfterDate, setRefundAfterDate] = useState<string>(
    getRefundStartDate().thirty_days_ago
  );
  const [refundDetails, setRefundDetails] = useState<TRefundDetails | null>(
    null
  );
  const [isRefundDetailsFetching, setIsRefundDetailsFetching] =
    useState<boolean>(false);

  useEffect(() => {
    const fetchRefundDetails = async () => {
      setIsRefundDetailsFetching(true);
      try {
        const response: any = await dispatch(
          getRefundDetailsRequest(
            { bundleId: id, startDate: refundAfterDate },
            token
          )
        );
        setRefundDetails(response as TRefundDetails);
        // setRefundDetails(dummyOrderRefundDetails);
      } catch (err) {
        console.log(err);
      } finally {
        setIsRefundDetailsFetching(false);
      }
    };

    fetchRefundDetails();
    // setRefundDetails(dummyOrderRefundDetails);
  }, [dispatch, id, refundAfterDate]);

  const handleDateSelection = (e: ChangeEvent<HTMLInputElement>) => {
    setRefundAfterDate(e.currentTarget.value);
  };

  return (
    <>
      <CloseGrey className="alert-modal-close-button" onClick={closeModal} />

      <div className={styles.processRefundWrapper}>
        <div className={styles.heading}>Process Refund</div>
        <div>{domainName}</div>

        <div className={styles.refundDateWrapper}>
          <label>Refund after</label>
          <input
            type="date"
            // min={minDate}
            max={getRefundStartDate().today}
            onFocus={showPicker}
            onChange={handleDateSelection}
            value={refundAfterDate}
          />
        </div>

        {isRefundDetailsFetching ? (
          <div className={styles.loadingSpinnerWrapper}>
            <LoadingSpinner />
          </div>
        ) : (
          <>
            {refundDetails?.orderRefundDetails?.length ? (
              <>
                <RefundDetails
                  currency={refundDetails.currency || 'USD'}
                  orderRefundDetails={refundDetails.orderRefundDetails}
                />
                <RefundOptions
                  orderRefundDetails={refundDetails.orderRefundDetails}
                  currency={refundDetails.currency || 'USD'}
                  startDate={refundAfterDate}
                  closeModal={closeModal}
                />
              </>
            ) : (
              <div className={styles.nothingToRefund}>
                <FormattedMessage id={'nothing_to_refund'} />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ProcessRefund;
